import { render, staticRenderFns } from "./DeleteAddressPopup.vue?vue&type=template&id=0ed16e31"
import script from "./DeleteAddressPopup.vue?vue&type=script&lang=js"
export * from "./DeleteAddressPopup.vue?vue&type=script&lang=js"
import style0 from "./DeleteAddressPopup.vue?vue&type=style&index=0&id=0ed16e31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports